import React, {Component} from 'react';
import {Grid} from '@material-ui/core';
import {connect} from 'react-redux';
import {T} from 'Actions/translate';
import util from 'Utils/commonUtil';
import Header from 'Components/common/Header';
import ScrollWrapper from '../common/ScrollWrapper';
import {openNotification} from 'Actions/notification';
import LoadingIcon from 'Components/icons/LoadingIcon';
import {
    getQuote,
    getCustomerQuote,
    getCartCount,
    getMoreProducts,
    operationLog,
} from 'Actions/order';
import {loadLanguage} from 'Utils/jwtUtil';

class OrderSuccess extends Component {
    state = {
        timer: 5,
        pageLoad: true,
        displayTMProduct: false,
        isDemoSite: false,
        isQuoteInfor: false,
    };

    intervalTimer = null;

    componentWillMount() {
        const {localData} = this.props;
        if (localData.roleType && !localData.isProxyProcess) {
            if (!this.getBatchAddSkuShipTo()) {
                window.clearInterval(this.intervalTimer);
                this.intervalTimer = setInterval(() => {
                    if (this.state.timer === 0) {
                        this.goToOrderList();
                    } else {
                        this.setState({timer: this.state.timer - 1});
                    }
                }, 1000);
            }
        }
    }

    getBatchAddSkuEmail = () => {
        let currentBatchAddSkuEmail = '';
        if (
            this.props.location.state &&
            this.props.location.state.bacthAddSkuEmail
        ) {
            currentBatchAddSkuEmail = this.props.location.state
                .bacthAddSkuEmail;
        }
        return currentBatchAddSkuEmail;
    };

    getBatchAddSkuShipTo = () => {
        let currentBatchAddSkuShipTo = '';
        if (
            this.props.location.state &&
            this.props.location.state.batchAddSkuShipTo
        ) {
            currentBatchAddSkuShipTo = this.props.location.state
                .batchAddSkuShipTo;
        }
        return currentBatchAddSkuShipTo;
    };

    goToOrderList = () => {
        const {localData} = this.props;

        if (localData.roleType && !localData.isProxyProcess) {
            if (this.getBatchAddSkuShipTo()) {
                this.props.history.replace('/myOrderList/unreceived');
            }
        } else {
            this.props.history.replace('/myOrderList/unreceived');
        }
    };

    // Hide API Get Loading
    hideloading = () => {
        this.setState({
            pageLoad: false,
        });
    };

    goToShoppingCart = () => {
        if (
            this.props.location.state &&
            this.props.location.state.supplyCenterId
        ) {
            this.props.history.push('/shoppingCart');
        } else {
            this.props.history.push('/shoppingCart', {
                batchAddShipTo: this.getBatchAddSkuShipTo(),
                batchAddEmail: this.getBatchAddSkuEmail(),
            });
        }
    };

    getQuote = (param) => {
        this.props.getCustomerQuote(
            param,
            this.props.localData,
            this.quoteCallback,
        );
        this.props.operationLog({
            opTarget: 'view_sku_promo_order',
            opContent: param,
            opReqUrl: 'api/quote/sku',
        });
    };

    quoteCallback = (res) => {
        if (res.status === 'success' && res.data.length !== 0) {
            this.setState({
                isQuoteInfor: true,
            });
        } else if (res.status === 'success' && res.data.length === 0) {
            this.props.openNotification(
                T('notification_quote_null'),
                'success',
            );
        } else {
            this.props.openNotification(
                T('notification_get_quote_failed'),
                'success',
            );
        }
    };

    viewSkuDetailOrderOperation = (sku) => {
        this.props.operationLog({
            opTarget: 'view_sku_detail_order',
            opContent: sku,
        });
    };

    render() {
        const {
            timer,
            displayTMProduct,
            pageLoad,
            isDemoSite,
            isQuoteInfor,
        } = this.state;
        const {
            localData,
            addOrder,
            submitF1Order,
            tmProductList,
            listLoaded,
            searchProductList,
            searchProductLoadingMore,
            cartCount,
            quoteInfor,
            quoteCustomerInfor,
        } = this.props;
        const chooseProductList = displayTMProduct
            ? tmProductList
            : searchProductList;
        const productAbyss = displayTMProduct
            ? true
            : chooseProductList.pageNum >= chooseProductList.pageTotal;

        let notificationInforBefor = T('notification_jump_to');
        let notificationInforAfter = T('notification_view_order_details');
        let orderSuccessHead = 'order-success-head';
        if (localData.roleType && !localData.isProxyProcess) {
            if (!this.getBatchAddSkuShipTo()) {
                notificationInforBefor = T('notification_jump_to');
                notificationInforAfter = T(
                    'notification_go_to_admin_view_f1_details',
                );
                orderSuccessHead =
                    'order-success-head container-max-width is-fixed';
            }
        }

        let foneOrderSuccessFlag = true;
        if (localData.roleType && localData.isProxyProcess) {
            foneOrderSuccessFlag = false;
        } else if (
            localData.roleType === 0 &&
            typeof localData.isProxyProcess === 'undefined'
        ) {
            foneOrderSuccessFlag = false;
        } else if (localData.roleType === 3 && !localData.isProxyProcess) {
            if (!this.getBatchAddSkuShipTo()) {
                foneOrderSuccessFlag = false;
            }
        }
        let lang = loadLanguage();

        return (
            <div className="order-success">
                <Grid
                    className={orderSuccessHead}
                    container
                    spacing={0}
                    justify={'space-evenly'}>
                    <Grid className="page-title" item xs={12}>
                        {!foneOrderSuccessFlag ? (
                            <Header
                                userIconEvent={this.goToUserCenter}
                                shoppingCartEvent={this.goToShoppingCart}
                                backEvent={this.backEvent}
                                increment={0}
                                hasShoppingCart={true}
                                hasUserCenter={true}
                                hasArrowBackIos={displayTMProduct}
                                cartCount={cartCount}
                                orderSubmitPage={true}
                                noHomeButton={true}></Header>
                        ) : (
                            <div>
                                <Header
                                    userIconEvent={this.goToUserCenter}
                                    shoppingCartEvent={this.goToShoppingCart}
                                    backEvent={this.backEvent}
                                    increment={0}
                                    hasShoppingCart={false}
                                    hasUserCenter={true}
                                    hasArrowBackIos={displayTMProduct}
                                    cartCount={cartCount}
                                    orderSubmitPage={true}
                                    noHomeButton={true}></Header>
                            </div>
                        )}
                    </Grid>
                </Grid>

                <Grid
                    className="order-content"
                    container
                    spacing={0}
                    justify={'space-evenly'}>
                    <Grid className="success-title" item xs={12}>
                        <span>{T('order_sumbit_success')}</span>
                    </Grid>
                    {localData.roleType &&
                    !localData.isProxyProcess &&
                    !this.getBatchAddSkuShipTo() ? (
                        <Grid className={'order-content-first'} item xs={12}>
                            {T('order_number_colon')}
                            {foneOrderSuccessFlag ? (
                                submitF1Order &&
                                submitF1Order.length > 0 &&
                                submitF1Order.map((f1order, i) => (
                                    <div key={i}>{f1order.number}</div>
                                ))
                            ) : (
                                <span>{submitF1Order.number}</span>
                            )}
                        </Grid>
                    ) : (
                        addOrder &&
                        addOrder.map((item, index) => (
                            <Grid
                                key={index}
                                className="order-content-first"
                                item
                                xs={12}>
                                {item.orderType === 'SCM'
                                    ? T('order_sc_order_number')
                                    : T('order_global_order_number')}
                                <span>{item.number}</span>
                            </Grid>
                        ))
                    )}

                    <Grid className="order-content-second" item xs={12}>
                        {notificationInforBefor}
                        <span onClick={this.goToOrderList}>
                            {localData.roleType && !localData.isProxyProcess
                                ? this.getBatchAddSkuShipTo()
                                    ? T('order_my_order')
                                    : ''
                                : T('order_my_order')}
                        </span>
                        {notificationInforAfter}
                    </Grid>
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const {localData, order, replenishment} = state;

    return {
        localData: localData,
        addOrder: order.addOrder,
        submitF1Order: replenishment.submitF1Order,
        tmProductList: order.tmProductList,
        listLoaded: order.searchProductListLoaded,
        searchProductList: order.searchProductList,
        searchProductLoadingMore: order.searchProductLoadingMore,
        cartCount: order.cartCount,
        quoteInfor: order.quoteInfor.data,
        quoteCustomerInfor: order.quoteCustomerInfor.data,
    };
};

const mapDispatchToProps = {
    getQuote,
    getCustomerQuote,
    openNotification,
    getCartCount,
    getMoreProducts,
    operationLog,
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderSuccess);
